import i18next from 'i18next';

// #3753 review round 2 (P3): `loginAsGuest` refuses with
// REAL_SESSION_UNVERIFIED when a real learner's token is held but not yet
// verified (#3406). ScenarioDetailPage shows `scenarioDetail.sessionUnverified`
// for its unverified-start refusal; the other guest-start surfaces
// (startGuestRun's callers, HomePageV2.handleCommitStart) showed a generic
// "something went wrong" instead. Same key, same English fallback.
//
// Kept out of startGuestRun.js on purpose: several suites mock that module
// wholesale, and this helper must stay real in them.
export const SESSION_UNVERIFIED_MESSAGE_KEY = 'scenarioDetail.sessionUnverified';
const SESSION_UNVERIFIED_FALLBACK =
  "We couldn't confirm your sign-in, so we haven't started the practice yet. Check your connection and try again.";

/**
 * The message a guest-start surface shows for a caught start error.
 * @param {unknown} err
 * @param {string} fallback - the surface's own generic message
 * @param {(key: string, opts?: object) => unknown} [t] - i18next translate fn;
 *   defaults to the global i18next instance for surfaces without useTranslation.
 * @returns {string}
 */
// #4724: a 429 from /auth/guest (`guestRateLimiter`, 5 per IP per hour) showed the generic "try again",
// which cannot succeed for up to an hour. ScenarioDetailPage already says why (#3012); same key here.
export const GUEST_RATE_LIMITED_MESSAGE_KEY = 'scenarioDetail.guestRateLimited';
const GUEST_RATE_LIMITED_FALLBACK = 'Too many new practice sessions from this network — try again in a few minutes.';

function translated(t, key, fallback) {
  let msg;
  try {
    msg = t(key, { defaultValue: fallback });
  } catch {
    msg = null;
  }
  return typeof msg === 'string' && msg && msg !== key ? msg : fallback;
}

export function guestStartErrorMessage(err, fallback, t = (key, opts) => i18next.t(key, opts)) {
  if (err?.code === 'REAL_SESSION_UNVERIFIED') return translated(t, SESSION_UNVERIFIED_MESSAGE_KEY, SESSION_UNVERIFIED_FALLBACK);
  if (err?.code === 'GUEST_RATE_LIMITED') return translated(t, GUEST_RATE_LIMITED_MESSAGE_KEY, GUEST_RATE_LIMITED_FALLBACK);
  // AuthContext's storageBlockedError already carries the translated "allow storage" sentence (#3578).
  if (err?.code === 'STORAGE_UNAVAILABLE' && typeof err.message === 'string' && err.message) return err.message;
  return fallback;
}

